import { useTranslation } from '@mc/i18n'
import { Locations } from '@mc/track-event'
import CTA from 'components/CTA'

export const QuizOnlyOnceHeading = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='d-flex align-items-center mc-h-100'>
      <div className='flex-1'>
        <div className='row no-gutters'>
          <div className='col-11 col-md-12 col-lg-11'>
            <div className='d-none d-md-block'>
              <h1 className='mc-text--brand mc-text-d2 mc-text--uppercase mc-mb-3'>
                {t('home.hero.title')}
              </h1>
            </div>
            <div className='d-block d-md-none'>
              <h1 className='mc-text--brand mc-text-d1 mc-text--uppercase mc-mb-3'>
                {t('home.hero.title')}
              </h1>
            </div>
          </div>
        </div>

        <div className='row no-gutters'>
          <div className='col-12 col-md-9 col-xl-7'>
            <h2 className='mc-text-h5 mc-text-color--tint mc-mb-8'>
              {t('home.hero.subtitle')}
            </h2>
          </div>
        </div>

        <div className='d-block d-md-none mc-mb-4'>
          <CTA
            trackProps={{
              type: 'all-access-pass',
              location: Locations.HERO,
            }}
            fullWidth
          />
        </div>
        <div className='d-none d-md-block'>
          <CTA
            trackProps={{
              type: 'all-access-pass',
              location: Locations.HERO,
            }}
          />
        </div>
      </div>
    </div>
  )
}
